import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const DashboardLayout = ({ children }) => {
  const { user, logout, isAdmin, isManager, isCashier, isChef, isWaiter } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // No hacer llamadas automáticas que den 403 — cada página se encarga de sus datos
  const menuItems = [
    ...(isWaiter ? [{ path: '/waiter', icon: '📝', label: 'Tomar Pedido' }] : []),
    ...(isChef ? [{ path: '/kitchen', icon: '👨‍🍳', label: 'Cocina' }] : []),
    ...(isCashier ? [{ path: '/cashier', icon: '💰', label: 'Caja' }] : []),
    ...(isManager ? [
      { path: '/admin/dashboard', icon: '📊', label: 'Dashboard' },
      { path: '/admin/reports', icon: '📈', label: 'Reportes' },
      { path: '/admin/reservations', icon: '📅', label: 'Reservas' },
      { path: '/admin/menu', icon: '🍽️', label: 'Gestionar Menú' },
      { path: '/admin/categories', icon: '🗂️', label: 'Categorías' },
      { path: '/admin/modifiers', icon: '⚙️', label: 'Modificadores' },
      { path: '/admin/tables', icon: '🪑', label: 'Mesas' },
    ] : []),
    ...(isAdmin ? [
      { path: '/admin/users', icon: '👥', label: 'Usuarios' },
    ] : []),
  ];

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <aside style={{
        width: 260,
        background: '#1e293b',
        borderRight: '1px solid #334155',
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        height: '100vh',
        overflowY: 'auto',
      }}>
        <div style={{ padding: '24px 20px', borderBottom: '1px solid #334155' }}>
          <h2 style={{ color: '#38bdf8', fontSize: 20, display: 'flex', alignItems: 'center', gap: 8 }}>
            🍽️ Restaurant AR
          </h2>
        </div>

        <nav style={{ flex: 1, padding: '16px 12px' }}>
          {menuItems.map((item) => (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '12px 16px',
                borderRadius: 10,
                border: 'none',
                background: location.pathname.startsWith(item.path) ? 'rgba(56, 189, 248, 0.1)' : 'transparent',
                color: location.pathname.startsWith(item.path) ? '#38bdf8' : '#94a3b8',
                fontSize: 14,
                fontWeight: 500,
                cursor: 'pointer',
                transition: 'all 0.2s',
                marginBottom: 4,
                textAlign: 'left',
              }}
            >
              <span style={{ fontSize: 18 }}>{item.icon}</span>
              {item.label}
            </button>
          ))}
        </nav>

        <div style={{ padding: '16px 20px', borderTop: '1px solid #334155' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
            <div style={{
              width: 36, height: 36, borderRadius: '50%',
              background: 'linear-gradient(135deg, #38bdf8, #0ea5e9)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontWeight: 'bold', color: '#0f172a', fontSize: 14,
            }}>
              {user?.name?.charAt(0)?.toUpperCase()}
            </div>
            <div style={{ overflow: 'hidden' }}>
              <p style={{ color: '#e2e8f0', fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {user?.name}
              </p>
              <p style={{ color: '#64748b', fontSize: 11 }}>{user?.role?.name}</p>
            </div>
          </div>
          <button
            onClick={logout}
            style={{
              width: '100%',
              padding: '10px',
              borderRadius: 8,
              border: '1px solid #334155',
              background: 'transparent',
              color: '#94a3b8',
              fontSize: 13,
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
          >
            Cerrar Sesión
          </button>
        </div>
      </aside>

      <main style={{ marginLeft: 260, flex: 1, padding: '24px 32px', minHeight: '100vh' }}>
        {children}
      </main>
    </div>
  );
};

export default DashboardLayout;